let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hqYks"), load("iLgOr"), load("dLkMK"), load("6ZETc"), load("U7y88"), load("d4MuV")]).then(() => parcelRequire('kBOGD'));